import * as loadjs from 'loadjs';
import '../polyfills';

export function startMain(main: loadjs.LoadedFn) {
    function needPolyfill(): boolean {
        if (!window.fetch || !window.Promise || !window.Symbol) {
            return true;
        }
        return false;
    }
    var readyCalled = false;
    function ready() {
        document.addEventListener('DOMContentLoaded', function () {
            if (readyCalled) {
                return;
            }
            readyCalled = true;
            main();
        });
    }
    if (needPolyfill()) {
        loadjs("https://app.genetics-gsa.org/includes/abstracts/polyfill.js", ready);
    } else {
        ready();
    }
}
